module.exports = __webpack_public_path__ + "9f31f9e2b749c75e1449eff6c07a28c2.pdf";